import type { FC } from 'react';

import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import { useUserPermissions } from 'api/subscriptions/hooks/useUserPermissions';

export const UserPermissions: FC = () => {
  const { data: permissions = [] } = useUserPermissions();

  return (
    <Table size='small'>
      <TableHead>
        <TableRow>
          <TableCell>Key</TableCell>
          <TableCell>Value</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {permissions.map((item, index) => (
          <TableRow key={`permissions_item_${index}`}>
            <TableCell>{index}</TableCell>
            <TableCell>{item}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
